import { ComputedRef } from 'vue'

import { Contest } from '@/domain/entities/problem/contest'
import { Course } from '@/domain/entities/problem/course'
import { ProblemSearchModalStateType } from '@/domain/value_objects/problem/problemModalStateType'
import { ProblemSearchModalStateViewModel } from '@/presentation/viewmodels/problem/problemSearchModalStateViewModel'

export class ProblemSearchModalStatePresenter {
  private viewModel: ProblemSearchModalStateViewModel

  constructor(viewModel: ProblemSearchModalStateViewModel) {
    this.viewModel = viewModel
  }

  get modalState(): ComputedRef<ProblemSearchModalStateType> {
    return this.viewModel.modalState
  }

  get selectedCourse(): ComputedRef<Course> {
    return this.viewModel.selectedCourse
  }

  get selectedContestList(): ComputedRef<Contest[]> {
    return this.viewModel.selectedContestList
  }

  setModalState(modalState: ProblemSearchModalStateType): void {
    this.viewModel.setModalState(modalState)
  }

  setSelectedCourse(course: Course): void {
    this.viewModel.setSelectedCourse(course)
  }

  setSelectedContestList(contest: Contest[]): void {
    this.viewModel.setSelectedContestList(contest)
  }
}
